import { Box, Container, Grid2, Stack } from '@mui/material'
import React, { memo } from 'react'
import { m } from 'framer-motion'
import { NavLink } from 'react-router-dom'
import { varAlpha } from 'minimal-shared/utils'

import { MotionViewport, varFade } from 'src/components/shared/animate'
import Text from '../shared/text/Text'
import Button from '../shared/button/Button'
import { Image } from '../shared/image'
import welcomeBanner from 'assets/welcome-banner.png'
import { SIGNUP_URL } from '../../constants/navigation'
import brandConfig from 'brandConfig'
import welcomeBannerBg from 'assets/welcome-bg.jpg'

const About = ({ t, onClickBenefits }) => {
  const { name } = brandConfig
  return (
    <Box
      component='section'
      sx={[
        (theme) => ({
          ...theme.mixins.bgGradient({
            images: [
              `linear-gradient(to right, ${varAlpha(theme.vars.palette.grey['900Channel'], 0.75)} 0%, ${theme.vars.palette.grey[900]} 75%)`,
              `url(${welcomeBannerBg})`
            ]
          })
        }),
        {
          bgcolor: 'background.neutral',
          height: {
            xs: '100%',
            md: 'calc(100vh - 72px)'
          }
        }
      ]}
    >
      <Container
        component={MotionViewport}
        sx={{
          textAlign: { xs: 'center', sm: 'center', md: 'unset' },
          height: '100%'
        }}
      >
        <Grid2 container sx={{ alignItems: 'center', height: '100%' }}>
          <Grid2 size={{ xs: 12, md: 6 }} sx={{ pt: { xs: 6, sm: 6, md: 0 } }}>
            <Text
              component={m.h2}
              variants={varFade('inLeft')}
              variant='h2'
              sx={{ mb: 3, lineHeight: 1.1, color: 'common.white' }}
              label={t('welcome.welcome-title', { name })}
            />

            <Text
              component={m.p}
              variants={varFade('inLeft')}
              sx={[
                {
                  color: 'common.white'
                }
              ]}
              label={t('welcome.welcome-desc', { name })}
            />

            <Stack
              direction='row'
              spacing={2}
              sx={{ mt: 5, justifyContent: { xs: 'center', md: 'unset' } }}
            >
              <NavLink to={SIGNUP_URL}>
                <Button
                  component={m.button}
                  variants={varFade('inLeft')}
                  color='primary'
                  label={t('welcome.sign-up-for-free')}
                  sx={{ textTransform: 'uppercase' }}
                />
              </NavLink>
              <Button
                component={m.button}
                variants={varFade('inLeft')}
                variant='outlined'
                color='primary'
                label={t('welcome.all-benefits')}
                onClick={onClickBenefits}
              />
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <m.div variants={varFade('inUp')}>
              <Image src={welcomeBanner} sx={{ overflow: 'unset' }} />
            </m.div>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  )
}

export default memo(About)
